// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Registration change',
  one: `1. Changing registration information <strong>immediately disconnects the user</strong>, so that a new credential is
  loaded with the updated information`,
  two: 'Any <strong>change is pending</strong> until it is validated with the user\'s password',
} as ILanguage;
